export default __webpack_public_path__ + "static/media/edit.c5a59d4d.svg";